export default "__VITE_ASSET__BRDww5Tu__"